import React, { useEffect, useState } from 'react'
import TitleWithBackNavigation from '../../../../components/TitleWithBackNavigation'
import { Col, Progress, Radio, Row } from 'antd'
import { TiTick } from "react-icons/ti";
import { useDispatch, useSelector } from 'react-redux';
import { fetchBadges } from '../../../../store/common/settingSlice';
import Circular from '../../../../components/Loader/Circular/Circular';



const Badges = () => {

    const dispatch = useDispatch();
    const [displayableBadge, setDisplayableBadge] = useState(null)
    const [badgeValue, setBadgeValue] = useState('all-badges')

    const { allbadges, loading, profileData } = useSelector(state => state?.setting);

    useEffect(() => {
        dispatch(fetchBadges())
    }, [])

    useEffect(() => {
        if (!loading && allbadges) {
            setDisplayableBadge(allbadges[0])
        }
    }, [allbadges])

    const radioValueHandler = (e) => {
        setBadgeValue(e?.target?.value)
    }

    const badgeHandler = (badge) => {
        setDisplayableBadge(badge)
    }

    //  to render a progress bar.
    const renderProgressBar = (badge) => {
        if (profileData?.badges) {
            let myBadge = profileData?.badges?.find(item => item?.name == badge?.name);
            if (myBadge && badge?.noOfServices) {
                return (
                    <div className='relative'>
                        <Progress
                            percent={badge?.noOfServices}
                            percentPosition={{ align: 'center', type: 'outer' }}
                            size={[50, 10]}
                            strokeColor={'#fab700'}
                        />
                        <span className='absolute left-0 bottom-[-2px]'>0</span>
                        <span className='absolute right-0 bottom-[-2px]'>{badge?.noOfServices}</span>
                    </div>
                )
            }
            else {
                if (badge?.noOfServices) {
                    return (
                        <div className='relative'>
                            <Progress
                                percent={((profileData?.noOfBookingCompleted / badge?.noOfServices) * 100)?.toFixed(2)}
                                percentPosition={{ align: 'center', type: 'outer' }}
                                size={[50, 10]}
                                strokeColor={'#fab700'}
                            />
                            <span className='absolute left-0 bottom-[-2px]'>0</span>
                            <span className='absolute right-0 bottom-[-2px]'>{badge?.noOfServices}</span>
                        </div>
                    )
                }
            }
        }
        else {
            return
        }
    }

    return (
        <div className='w-full'>
            <TitleWithBackNavigation title={'Badges'} link={'/settings'} />
            <Row justify={'space-between'} className='w-full mx-auto bg-white px-3 py-3 font-semibold rounded-md mt-4 badge-radio flex flex-col items-center justify-center gap-4'>
                <Radio.Group optionType="button" buttonStyle="solid" value={badgeValue} onChange={(e) => radioValueHandler(e)}>
                    <Radio value={'all-badges'}>
                        <div className='flex items-center gap-2'>
                            <div className={`rounded-full w-4 h-4 flex items-center justify-center ${badgeValue !== 'all-badges' ? 'border border-gray-400' : 'bg-[#fab700]'}`}>
                                {
                                    badgeValue == 'all-badges' && <TiTick color='black' />
                                }
                            </div>
                            All badges
                        </div>
                    </Radio>
                    <Radio value={'my-badges'}>
                        <div className='flex items-center gap-2'>
                            <div className={`rounded-full w-4 h-4 flex items-center justify-center ${badgeValue !== 'my-badges' ? 'border border-gray-400' : 'bg-[#fab700]'}`}>
                                {
                                    badgeValue == 'my-badges' && <TiTick color='black' />
                                }
                            </div>
                            My badges
                        </div>
                    </Radio>
                </Radio.Group>
                {
                    badgeValue == 'all-badges' ?
                        loading ?
                            <Circular color={'#fab700'} size={25} />
                            :
                            allbadges && allbadges?.length > 0
                                ?
                                <Row className='max-w-[600px] w-full p-2 gap-4'>
                                    <Col span={24} className='badges-display-bg py-4 px-2 flex flex-col justify-center items-center gap-2'>
                                        {
                                            displayableBadge &&
                                            <>
                                                <img src={displayableBadge?.imageUrl} alt={displayableBadge?.name} className='w-40 h-40 object-contain object-center' onError={(e) => { e.target.style.display = 'none' }} />
                                                <p className='text-lg font-semibold'>{displayableBadge?.name ? displayableBadge?.name : '-'}</p>
                                                <p className='text-wrap text-center text-xs font-medium'>{displayableBadge?.description ? displayableBadge?.description : '-'}</p>
                                            </>
                                        }
                                    </Col>
                                    <Col span={24} className='w-full'>
                                        <div className='max-w-[600px] overflow-x-scroll whitespace-nowrap flex items-center gap-3 px-2'>
                                            {
                                                allbadges?.map((badge, index) => {
                                                    return (
                                                        <div className={`flex flex-col gap-2 items-center w-fit cursor-pointer`} key={index} onClick={() => badgeHandler(badge)}>
                                                            <div className={`badges-display-bg rounded-md p-2 w-20 h-20 ${displayableBadge && displayableBadge?.name == badge?.name && 'border border-dashed border-[#fab700] bg-[#F3F6F8]'}`}>
                                                                <img src={badge?.imageUrl} alt={badge?.name} className='w-full h-full object-contain' onError={(e) => { e.target.style.display = 'none' }} />
                                                            </div>
                                                            <p className='text-base font-medium text-wrap'>{badge?.name ? badge?.name : '-'}</p>
                                                        </div>
                                                    )
                                                })

                                            }
                                        </div>
                                    </Col>
                                </Row>
                                :
                                <p>No badges available</p>
                        :
                        profileData?.badges?.length > 0 ?
                            <Row className='max-w-[800px] w-full p-1 gap-4'>
                                {
                                    allbadges?.map((badge, index) => {
                                        return (
                                            <Col span={24} className='bg-[#F4F4FA] p-3 rounded-md flex justify-between items-center  flex-wrap md:flex-nowrap gap-2 md:p-2' key={index}>
                                                <div className='w-full md:w-[70%] flex items-start md:items-center justify-start gap-4'>
                                                    <div className='w-20 object-contain object-center p-3 bg-white rounded-md'>
                                                        <img src={badge?.imageUrl} alt={badge?.name} className='w-full h-full' onError={(e) => { e.target.style.display = 'none' }} />
                                                    </div>
                                                    <div className='flex flex-col items-start'>
                                                        <h3 className='font-semibold text-base'>{badge?.name ? badge?.name : '-'}</h3>
                                                        <p className='font-normal text-xs text-[#42425B] text-wrap'>{badge?.description ? badge?.description : '-'}</p>
                                                    </div>
                                                </div>
                                                {
                                                    badge?.name !== 'Verified Expert' ?
                                                        <div className='w-full md:w-[30%]'>
                                                            {renderProgressBar(badge)}
                                                        </div>
                                                        :
                                                        ''
                                                }

                                            </Col>
                                        )
                                    })
                                }
                            </Row>
                            :
                            <p>No badges available</p>
                }
            </Row>
        </div>
    )
}

export default Badges